import { useCallback } from 'react'

import { useLocation, useNavigate } from 'Pods/Shared/ContextBasedRouter'
import { STUDIO_PATH } from 'Pods/ThreeDStudio/constants'
import { threeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { clearModelSettings, setInputImage } from 'Pods/ThreeDStudio/Store/actions/modelSettings'
import { closeFullImageEditor, closeImageAssistant } from 'Pods/ThreeDStudio/Store/actions/ui'

// Makes a generated image the 3D generator's input from outside the generate form, the
// way the Create conversation's "Use for 3D Generation" does from the panel over it. The
// library can be used from any studio page, so this also takes the user to the form:
// it closes the full-width editor, which would cover it on /ai, and navigates to /ai.
//
// An opened model's settings are discarded first, as the New Model card does, so the
// image does not land in the form of the model being left. Otherwise the composition in
// progress is kept and only its input image changes, as it is from the panel.
function useApplyImageToThreeD(onNavigate) {
  const navigate = useNavigate()
  const location = useLocation()

  return useCallback((image) => {
    if (threeDStudioStore.getState().ui?.openedModel?.id != null) {
      clearModelSettings()
    }
    closeImageAssistant()
    closeFullImageEditor()
    setInputImage(image.id, image.url)

    // Compared with the search string, as the New Model card does, so /ai?run=<id>
    // still navigates and stops highlighting the generating card.
    if (`${location?.pathname ?? ''}${location?.search ?? ''}` !== STUDIO_PATH.GENERATE) {
      navigate(STUDIO_PATH.GENERATE)
    }
    onNavigate('new')
  }, [navigate, location, onNavigate])
}

export default useApplyImageToThreeD
